export default __webpack_public_path__ + "static/media/profile_tip_socials.b4c24aed.svg";